const SHARE_IMAGE_FILENAME = "chuffed-share-image.png";
export const isMobileDevice = () => {
    if (typeof navigator === "undefined") {
        return false;
    }
    if (/Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        return true;
    }
    // iPadOS reports a desktop "Macintosh" user agent, so fall back to a touch-point check.
    return /Macintosh/i.test(navigator.userAgent) && navigator.maxTouchPoints > 0;
};
export const buildShareData = (url, imageBlob) => {
    var _a;
    if (!imageBlob) {
        return { url };
    }
    const file = new File([imageBlob], SHARE_IMAGE_FILENAME, { type: "image/png" });
    return ((_a = navigator.canShare) === null || _a === void 0 ? void 0 : _a.call(navigator, { files: [file] })) ? { url, files: [file] } : { url };
};
export const handleShare = (shareUrl, imageBlob) => {
    if (!imageBlob) {
        return;
    }
    navigator.share(buildShareData(shareUrl, imageBlob)).catch(() => { });
};
export const canNativeShare = () => typeof navigator !== "undefined"
    && typeof navigator.share === "function";
